import * as React from "react"
import { cn } from "../../lib/utils"

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <label className="flex items-center space-x-2 cursor-pointer">
        <div className="relative">
          <input
            type="checkbox"
            className="sr-only"
            ref={ref}
            {...props}
          />
          <div
            className={cn(
              "block w-11 h-6 bg-gray-200 rounded-full transition-colors duration-200 ease-in-out",
              props.checked && "bg-green-500",
              className
            )}
          />
          <div
            className={cn(
              "absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-200 ease-in-out",
              props.checked && "transform translate-x-5"
            )}
          />
        </div>
        {label && (
          <span className="text-sm font-medium text-gray-700">{label}</span>
        )}
      </label>
    )
  }
)
Switch.displayName = "Switch"

export { Switch } 
